// import React from 'react';
// import MyComponent from './MyComponent';
// import Card from './Card';
// import './App.css';
// import Navbar from "./Navbar";


// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <Navbar/>
//         <MyComponent />
//         <Card/>
//       </header>
//     </div>
//   );
// }

// export default App;

import React, { useState } from "react";
import MyComponent from "./MyComponent";
import Card from "./Card";
import "./App.css";
import Navbar from "./Navbar";
import WorkInProgress from "./WorkInProgress";

function App() {
  const [showWip, setShowWip] = useState(false);

  return (
    <div className="App">
      <header className="App-header">
        <Navbar onWip={() => setShowWip(true)} />

        {showWip && <WorkInProgress onClose={() => setShowWip(false)} />}

        <MyComponent />
        <Card />
      </header>
    </div>
  );
}

export default App;
